import { configureStore } from '@reduxjs/toolkit'

import globalReducer from './globalSlice'
import licensesReducer from './licensesSlice'
import libraryReducer from './librarySlice'
import activationsReducer from './activationsSlice'
import creditsReducer from './creditsSlice'
import topupsReducer from './topupsSlice'
import productsReducer from './productsSlice'
import ordersReducer from './ordersSlice'
import usersReducer from './usersSlice'
import profilesReducer from './profilesSlice'
import plansReducer from './plansSlice'
import skusReducer from './skusSlice'
import claimsReducer from './claimsSlice'
import storeReducer from './storeSlice'
import subscriptionReducer from './subscriptionSlice'
import redemptionsReducer from './redemptionsSlice'
import pointsReducer from './pointsSlice'
import pointTopupsReducer from './pointTopupsSlice'
import pointSpendingsReducer from './pointSpendingsSlice'

export const store = configureStore({
  reducer: {
    global: globalReducer,
    licenses: licensesReducer,
    library: libraryReducer,
    activations: activationsReducer,
    credits: creditsReducer,
    topups: topupsReducer,
    products: productsReducer,
    orders: ordersReducer,
    users: usersReducer,
    profiles: profilesReducer,
    plans: plansReducer,
    skus: skusReducer,
    claims: claimsReducer,
    store: storeReducer,
    subscription: subscriptionReducer,
    redemptions: redemptionsReducer,
    points: pointsReducer,
    pointTopups: pointTopupsReducer,
    pointSpendings: pointSpendingsReducer,
  },
  devTools: {
    features: {
      persist: false      // to clear state on every reload, otherwise it can cause issues with development
    }
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
